import { applyBillingFilters } from 'src/app/shared/utils/billing-filter.utils';
import { Component, ElementRef, OnInit, ViewChild, OnDestroy, inject } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BreadcrumbService } from 'xng-breadcrumb';
import { IconsService } from 'src/app/shared/services/icons.service';
import { GodModeService } from 'src/app/shared/services/god-mode.service';
import { NgbDate, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { FullFilterComponent } from 'src/app/components/offcanvas/full-filter.component';
import { Subscription } from 'rxjs';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { lastMonthDay } from 'src/app/shared/utils/utils';

@Component({
  selector: 'app-invoices',
  template: `
    <div class="d-flex mb-4 mt-4">
      <div class="flex-fill">
        <h1>Facturación</h1>
      </div>
    </div>
    <div class="flex-fill">
      <div class="d-flex">
        <div class="me-3" style="width: 222px !important; min-width: 222px !important;">
          <ul #sidebar app-nav-invoices [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
        </div>
        <div #pages class="flex-fill">
          <div class="d-flex">
            <div>
              <div ngbDropdown class="d-inline-block" (click)="datepicker.toggle()">
                <button type="button" 
                  class="btn btn-zazz-default rounded-4 px-4 shadow-sm" 
                  id="dropdownForm1" 
                  ngbDropdownToggle>
                  <fa-icon [icon]="icons.faCalendarAlt" class="me-2"></fa-icon>
                  Este mes
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownForm1" class="shadow" style="width: 650px;">
                  <div class="row" (click)="$event.stopPropagation()">
                    <div class="col-3">
                      <ul class="list-group calendar-list-group ps-2 mt-2">
                        <li #1day class="list-group-item list-group-item-action active">Hoy</li>
                        <li #yesterday class="list-group-item list-group-item-action">Ayer</li>
                        <li #1mes class="list-group-item list-group-item-action" (click)="updateFilter(1)">Este mes</li>
                        <li #3mes class="list-group-item list-group-item-action" (click)="updateFilter(3)">3 meses</li>
                        <li #6mes class="list-group-item list-group-item-action" (click)="updateFilter(6)">6 meses</li>
                        <li #12mes class="list-group-item list-group-item-action" (click)="updateFilter(12)">12 meses</li>
                        <li #custom class="list-group-item list-group-item-action">Personalizado</li>
                      </ul>
                    </div>
                    <div class="col-9" style="height: 320px;">
                      <div class="input-group">
                        <input
                          #dpFromDate
                          class="form-control"
                          style="width: 0px !important; height: 0px !important; opacity: 0;"
                          ngbDatepicker
                          #datepicker="ngbDatepicker"
                          [autoClose]="'outside'"
                          (dateSelect)="onDateSelection($event)"
                          [displayMonths]="2"
                          [dayTemplate]="t"
                          outsideDays="hidden"
                          [startDate]="fromDate!"
                          tabindex="-1" 
                        />
                        <ng-template #t let-date let-focused="focused">
                          <span
                            class="custom-day"
                            [class.focused]="focused"
                            [class.range]="isRange(date)"
                            [class.faded]="isHovered(date) || isInside(date)"
                            [class.selected]="date.equals(fromDate) || (toDate && date.equals(toDate))"
                            (mouseenter)="hoveredDate = date"
                            (mouseleave)="hoveredDate = null"
                          >
                            {{ date.day }}
                          </span>
                        </ng-template>
                      </div>
                    </div>
                  </div>                  
                </div>
              </div>
            </div>
            <div class="flex-fill">
              <button class="btn btn-zazz-default rounded-4 px-4 ms-2 shadow-sm" (click)="openFilters()">
                <fa-icon [icon]="icons.faSliders" class="me-2"></fa-icon>
                Filtrar búsqueda
              </button>
              <button class="btn btn-outline-secondary rounded-4 px-4 ms-2 shadow-sm" (click)="resetFilters()">
                <fa-icon [icon]="icons.faRotateLeft" class="me-2"></fa-icon>
                Limpiar filtros
              </button>
              <app-invoice-csv-export-button
                [filters]="payFilterPrefs"
                fileName="facturas-ingreso"
                reportTitle="Reporte de facturas de ingreso"
                [disabled]="loading"
              ></app-invoice-csv-export-button>
            </div>
            <div class="flex-fill ms-2">
              <!-- input type="text" class="form-control rounded-4 border border-1 border-secondary" placeholder="Buscar recibo" formControlName="search" -->
            </div>
          </div>
          <div class="flex-fill list-group rounded-5 shadow mt-4">
            <div class="list-group-item" *ngIf="invoices.length > 0">
              <table class="table table-sm">
                <thead class="thead-dark">
                  <tr class="">
                    <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2 ps-3"><strong># Recibo</strong></th>
                    <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2"><strong>Folio</strong></th>
                    <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2"><strong>Unidad</strong></th>
                    <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2"><strong>Razón social</strong></th>
                    <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2"><strong>Emitida</strong></th>
                    <th scope="col" class="bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2"><strong>Tipo</strong></th>
                  </tr>
                </thead>
                <tbody>
                  <tr app-tr-invoices 
                    [invoice]="invoice"
                    *ngFor="let invoice of invoices | paginate: { itemsPerPage: payFilterPrefs.per_page, currentPage: p, totalItems: meta.total_entries }"
                  ></tr>
                </tbody>
              </table>
            </div>
            <div class="list-group-item" *ngIf="invoices.length==0&&loading">
              <div class="text-center py-5">
                <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
                <p class="text-muted">Cargando...</p>
              </div>
            </div>
            <div class="list-group-item" *ngIf="invoices.length==0&&!loading">
              <div class="text-center py-5">
                <img src="/assets/images/empty-state.png" width="240px">
                <p class="text-muted">No se encontraron registros</p>
              </div>
            </div>
            <div class="list-group-item text-center pt-3">
              <pagination-controls
                (pageChange)="p = $event"
                (pageChange)="pageChanged($event)"
                previousLabel="Prev."
                nextLabel="Sig."
                screenReaderPaginationLabel="Pagination"
                screenReaderPageLabel="page"
              ></pagination-controls>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  `,
  styleUrls: []
})
export class InvoicesComponent implements OnInit, OnDestroy {
  invoices: any[] = [];
  meta: any = {};
  profile: any = {};
  permissions: any = {};
  godmode: boolean = false;

  @ViewChild('1day') oneDay !: ElementRef;
  @ViewChild('yesterday') yesterday !: ElementRef;
  @ViewChild('1mes') oneMonth !: ElementRef;
  @ViewChild('3mes') threeMonth !: ElementRef;
  @ViewChild('6mes') sixMonth !: ElementRef;
  @ViewChild('12mes') twelveMonth !: ElementRef;
  @ViewChild('custom') custom !: ElementRef;
  @ViewChild('datepicker') datepicker: any;

  currentView: string = 'invoices';

  searchBox: FormGroup = new FormGroup({});
  loading: boolean = false;
  searchActive: boolean = false;

  payload: any = {
    page: 1,
    per_page: 50,
    tipo: 0,
    created_at_since: '',
    created_at_to: '',
    sort: 'created_at',
    order: 'DESC'
  };

  p: number = 1;

  a = new Date();
  fromDate;
  toDate: NgbDate | null;

  hoveredDate: NgbDate | null = null;

  payFilterPrefs: any = {};

  private godModeSubscription: Subscription = new Subscription();
  storageService = inject(StorageService);
  constructor(
    private store : SettlementsService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    public icons: IconsService,
    private godModeService: GodModeService,
    private offcanvasService: NgbOffcanvas,
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
    this.godmode = this.godModeService.getGodMode();
    this.payload.profile_id = this.profile.id;

    const adjustedDate = new Date(this.a.getFullYear(), this.a.getMonth(), this.a.getDate());

    this.fromDate = new NgbDate(adjustedDate.getFullYear(), adjustedDate.getMonth()+1, 1);
    this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, lastMonthDay(this.a.getFullYear(), this.a.getMonth()));
    //
    this.payload.created_at_since = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
    this.payload.created_at_to = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;

    this.payFilterPrefs = this.storageService.getItem(STORAGE_KEYS.PAYFILTERSPREFS) ? this.storageService.getItem(STORAGE_KEYS.PAYFILTERSPREFS) : this.payload;
    this.payFilterPrefs.tipo = 0;
    
    // Set profile_id based on god mode state
    if (!this.godmode) {
      this.payFilterPrefs.profile_id = this.profile.id;
    } else {
      delete this.payFilterPrefs.profile_id;
    }
    
    this.p = this.payFilterPrefs.page;

    this.loadInvoices(this.payFilterPrefs);
  }
  
  ngOnInit(): void {
    // Subscribe to god mode changes
    this.godModeSubscription = this.godModeService.godMode$.subscribe(
      (godMode: boolean) => {
        this.godmode = godMode;
        // Update payFilterPrefs based on god mode
        if (!this.godmode) {
          this.payFilterPrefs.profile_id = this.profile.id;
        } else {
          delete this.payFilterPrefs.profile_id;
        }
        // Reload invoices when god mode changes
        this.loadInvoices(this.payFilterPrefs);
      }
    );

    setTimeout(() => {
      this.datepicker.open();
    });
  }

  ngOnDestroy(): void {
    this.godModeSubscription.unsubscribe();
  }

  updateDate(event: any) {
    this.fromDate = event.from;
    this.toDate = event.to;

    if (this.toDate?.after(this.fromDate) || this.toDate?.equals(this.fromDate)) {
      this.payFilterPrefs.created_at_since = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
      this.payFilterPrefs.created_at_to = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
      this.loadInvoices(this.payFilterPrefs);
    }
  }

  loadInvoices(payload: any) {
    this.loading = true;
    this.store.getInvoicesQuery(payload).subscribe({
      next: (invoices: any) => {
        this.invoices = invoices.data;
        this.meta = invoices.meta;
        this.loading = false;
        this.storageService.saveItem(STORAGE_KEYS.PAYFILTERSPREFS, this.payFilterPrefs);
      },
      error: (err: any) => {
        console.log(err.status);
        this.loading = false;
        this.invoices = [];
        if (err.status === 500) {
          this.toastr.error('Ocurrió un error al obtener las facturas.', 'Error');
        }
      }
    });
  }

  loadInvoicesBySettlement(settlement_id: any) {
    this.payFilterPrefs.settlement_id = settlement_id;    
    this.payFilterPrefs.page = 1;
    this.p = 1;

    delete this.payFilterPrefs.building_id;
    delete this.payFilterPrefs.floor_id;
    delete this.payFilterPrefs.unit_id;

    console.log('PAYFILTERPREFS', this.payFilterPrefs);

    this.loadInvoices(this.payFilterPrefs);
  }

  loadInvoicesByBuilding(building_id: any) {
    this.payFilterPrefs.building_id = building_id;
    this.payFilterPrefs.page = 1;
    this.p = 1;

    delete this.payFilterPrefs.floor_id;
    delete this.payFilterPrefs.unit_id;

    this.loadInvoices(this.payFilterPrefs);
  }

  loadInvoicesByFloor(floor_id: any) {
    this.payFilterPrefs.floor_id = floor_id;
    this.payFilterPrefs.page = 1;
    this.p = 1;

    delete this.payFilterPrefs.unit_id;

    this.loadInvoices(this.payFilterPrefs);
  }

  loadInvoicesByUnit(unit_id: any) {
    this.payFilterPrefs.unit_id = unit_id;
    this.payFilterPrefs.page = 1;
    this.p = 1;

    this.loadInvoices(this.payFilterPrefs);
  }

  loadInvoicesSort(event: any) {
    this.payFilterPrefs.sort = event;
    this.loadInvoices(this.payFilterPrefs);
  }

  loadInvoicesOrder(event: any) {
    this.payFilterPrefs.order = event;
    this.loadInvoices(this.payFilterPrefs);
  }

  loadInvoicesPerPage(event: any) {
    this.payFilterPrefs.per_page = event;
    this.loadInvoices(this.payFilterPrefs);
  }

  clearFilter() {
    delete this.payFilterPrefs.legal_entity_id;
    this.payFilterPrefs.page = 1;
    this.p = 1;

    delete this.payFilterPrefs.settlement_id;
    delete this.payFilterPrefs.building_id;
    delete this.payFilterPrefs.floor_id;
    delete this.payFilterPrefs.unit_id;

    // Respect god mode state when clearing filters
    if (!this.godmode) {
      this.payFilterPrefs.profile_id = this.profile.id;
    } else {
      delete this.payFilterPrefs.profile_id;
    }

    this.loadInvoices(this.payFilterPrefs);
  }

  pageChanged(event: any) {
    this.payFilterPrefs.page = event;
    this.loadInvoices(this.payFilterPrefs);
  }

  tag(status: any) {
    if (status === 'active') {
      return 'Activo';
    } else {
      return 'Inactivo';
    }
  }

  openFilters() {
    const offcanvasRef = this.offcanvasService.open(FullFilterComponent, {
      position: 'end',
      animation: true,
      backdrop: true,
      keyboard: true,
      scroll: true,
      backdropClass: 'bg-dark',
      panelClass: 'bg-light',
    });

    offcanvasRef.componentInstance.payload = this.payFilterPrefs;
    offcanvasRef.componentInstance.profile = this.profile;
    offcanvasRef.componentInstance.showLegalEntity = true;
    offcanvasRef.result.then((result: any) => {
      console.log('result => ', result);
      this.payFilterPrefs = applyBillingFilters(this.payFilterPrefs, result);
      this.p = 1;
      this.payFilterPrefs.tipo = 0;
      this.payFilterPrefs.all = true;
      
      // Respect god mode state when applying filters
      if (!this.godmode) {
        this.payFilterPrefs.profile_id = this.profile.id;
      } else {
        delete this.payFilterPrefs.profile_id;
      }
      
      this.loadInvoices(this.payFilterPrefs);
    });
  }

  resetFilters() {
    const adjustedDate = new Date(this.a.getFullYear(), this.a.getMonth(), this.a.getDate());
    const testDate = new Date(this.a.getFullYear(), 1, 15);
    const lastDay = new Date(testDate.getFullYear(), testDate.getMonth() + 1, 0);

    this.fromDate = new NgbDate(adjustedDate.getFullYear(), adjustedDate.getMonth()+1, 1);
    this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, lastDay.getDate());
    // Reset to initial payload values
    this.payFilterPrefs = {
      page: 1,
      per_page: 50,
      status: true,
      tipo: 0,
      sort: 'created_at',
      order: 'DESC',
      profile_id: this.profile.id,
      all: true,
      created_at_since: this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day,
      created_at_to: this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day
    };

    if (!this.godmode) {
      this.payFilterPrefs.profile_id = this.profile.id; // Set profile_id for non-godmode users
    } else {
      delete this.payFilterPrefs.profile_id;
    }

    // Remove any additional filters
    delete this.payFilterPrefs.settlement_id;
    delete this.payFilterPrefs.building_id;
    delete this.payFilterPrefs.floor_id;
    delete this.payFilterPrefs.unit_id;

    // Reset page
    this.p = 1;

    // Reset active states on filter buttons
    this.oneDay?.nativeElement.classList.remove('active');
    this.yesterday?.nativeElement.classList.remove('active');
    this.oneMonth?.nativeElement.classList.add('active');
    this.threeMonth?.nativeElement.classList.remove('active');
    this.sixMonth?.nativeElement.classList.remove('active');
    this.twelveMonth?.nativeElement.classList.remove('active');
    this.custom?.nativeElement.classList.remove('active');

    // Update localStorage
    this.storageService.saveItem(STORAGE_KEYS.PAYFILTERSPREFS, this.payFilterPrefs);

    // Reload bills with reset filters
    this.loadInvoices(this.payFilterPrefs);
  }

  updateFilter(mes: number) {
    setTimeout(() => {
      this.datepicker.open();
    });

    if (mes === 0) {
      // Handle yesterday
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      
      this.fromDate = new NgbDate(yesterday.getFullYear(), yesterday.getMonth() + 1, yesterday.getDate());
      this.toDate = new NgbDate(yesterday.getFullYear(), yesterday.getMonth() + 1, yesterday.getDate());
      
      // Update active states
      this.oneDay.nativeElement.classList.remove('active');
      this.yesterday.nativeElement.classList.add('active');
      this.oneMonth.nativeElement.classList.remove('active');
      this.threeMonth.nativeElement.classList.remove('active');
      this.sixMonth.nativeElement.classList.remove('active');
      this.twelveMonth.nativeElement.classList.remove('active');
      this.custom.nativeElement.classList.remove('active');
    } else {
      const today = new Date();
      today.setMonth(today.getMonth() - mes);
      const adjustedDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const testDate = new Date(this.a.getFullYear(), 1, 15); // February 15, 2025 (months are 0-indexed)
      const lastDay = new Date(testDate.getFullYear(), testDate.getMonth() + 1, 0);

      this.fromDate = new NgbDate(adjustedDate.getFullYear(), adjustedDate.getMonth()+1, 1);
      this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, lastDay.getDate());

      this.payFilterPrefs.created_at_since = `${this.fromDate?.year}-${this.fromDate?.month}-${this.fromDate?.day}`;
      this.payFilterPrefs.created_at_to = `${this.toDate?.year}-${this.toDate?.month}-${this.toDate?.day}`;

      this.loadInvoices(this.payFilterPrefs);

      if (mes == 1) {
        this.oneMonth.nativeElement.classList.add('active');
        this.threeMonth.nativeElement.classList.remove('active');
        this.sixMonth.nativeElement.classList.remove('active');
        this.twelveMonth.nativeElement.classList.remove('active');
        this.custom.nativeElement.classList.remove('active');
      }
      if (mes == 3) {
        this.oneMonth.nativeElement.classList.remove('active');
        this.threeMonth.nativeElement.classList.add('active');
        this.sixMonth.nativeElement.classList.remove('active');
        this.twelveMonth.nativeElement.classList.remove('active');
        this.custom.nativeElement.classList.remove('active');
      }
      if (mes == 6) {
        this.oneMonth.nativeElement.classList.remove('active');
        this.threeMonth.nativeElement.classList.remove('active');
        this.sixMonth.nativeElement.classList.add('active');
        this.twelveMonth.nativeElement.classList.remove('active');
        this.custom.nativeElement.classList.remove('active');
      }
      if (mes == 12) {
        this.oneMonth.nativeElement.classList.remove('active');
        this.threeMonth.nativeElement.classList.remove('active');
        this.sixMonth.nativeElement.classList.remove('active');
        this.twelveMonth.nativeElement.classList.add('active');
        this.custom.nativeElement.classList.remove('active');
      }
    }
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
			this.fromDate = date;
		} else if (this.fromDate && !this.toDate && date) {
      this.toDate = date;
      if (this.fromDate.after(this.toDate)) {
        // If fromDate is after toDate, swap them
        const temp = this.fromDate;
        this.fromDate = this.toDate;
        this.toDate = temp;
      }
		} else {
			this.toDate = null;
			this.fromDate = date;
		}

    if (this.fromDate && this.toDate) {
      this.payFilterPrefs.created_at_since = `${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day}`;
      this.payFilterPrefs.created_at_to = `${this.toDate.year}-${this.toDate.month}-${this.toDate.day}`;
      this.loadInvoices(this.payFilterPrefs);
    }
	}

	isHovered(date: NgbDate) {
    return (
      this.fromDate && 
      !this.toDate && 
      this.hoveredDate && 
      date.after(this.fromDate) && 
      date.before(this.hoveredDate)
    );
  }

    isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && 
          date.after(this.fromDate) && 
          date.before(this.toDate);
  }
}
